import { render, staticRenderFns } from "./DeliveryChangeRequestModal.vue?vue&type=template&id=671faa2c"
import script from "./DeliveryChangeRequestModal.vue?vue&type=script&lang=js"
export * from "./DeliveryChangeRequestModal.vue?vue&type=script&lang=js"
import style0 from "./DeliveryChangeRequestModal.vue?vue&type=style&index=0&id=671faa2c&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports